import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./Components/Layout/Layout";
import OrgLayout from "./Components/Layout/OrgLayout";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import { ToastContainer } from "react-toastify";
import CreateAdmin from "./pages/AdminUsers/CreateAdmin";
import CreateRole from "./pages/Roles/CreateRole";
import Category from "./pages/Categories/Category";
import UpdateCategory from "./pages/Categories/UpdateCategory";
import AddCategory from "./pages/Categories/AddCategory";
import Subcategory from "./pages/SubCategory/Subcategory";
import UpdateSubCategory from "./pages/SubCategory/UpdateSubCategory";
import AddSubCategory from "./pages/SubCategory/AddSubCategory";
import Roles from "./pages/Roles/Roles";
import Permissions from "./pages/Permission";
import AssignPermissions from "./pages/Permission/AssignPermissions";
import Faq from "./pages/Faq/Faq";
import AdminUsers from "./pages/AdminUsers/AdminUsers";
import Offerlist from "./pages/Offer/index";
import AddOffer from "./pages/Offer/AddOffer";
import EditOffer from "./pages/Offer/Edit";
import UserTopUp from "./pages/UserTopUp";
import Bannerlist from "./pages/Banner/index";
import AddBanner from "./pages/Banner/AddBanner";
import EditBanner from "./pages/Banner/Edit";
import OrganizationVideoList from "./pages/OrganizationVideos/OrganizationVideoList";
import AddOrganizationVideo from "./pages/OrganizationVideos/AddOrganizationVideo";
import EditOrganizationVideo from "./pages/OrganizationVideos/EditOrganizationVideo";
import OrganizationList from "./pages/Organization/OrganizationList";
import AddOrganization from "./pages/Organization/AddOrganization";
import UpdateOrganization from "./pages/Organization/UpdateOrganization";
import CheckThisOut from "./pages/CheckThisOut/index.js";
import AddCheckThisOut from "./pages/CheckThisOut/AddCheckThisOut.js";
import EditCheckThisOut from "./pages/CheckThisOut/EditCheckThisOut.js";
import Place from "./pages/Place/index";
import AddPlace from "./pages/Place/AddPlace";
import EditPlace from "./pages/Place/EditPlace";
import AddPlaceDetails from "./pages/PlaceDetails/AddPlaceDetails";
import AddTicketType from "./pages/TicketInfo/AddTicketType"
import TicketInfo from "./pages/TicketInfo/TicketInfo"
import PlaceZone from "./pages/TicketInfo/PlaceZone"
import SafariVehicles from "./pages/TicketInfo/SafariVehicles"
import GalleryIndex from "./pages/Gallery";
import HomePageIndex from "./pages/HomePage";
import AddGallery from "./pages/Gallery/AddGallery";
import AddHome from "./pages/HomePage/AddHome";
import EditGallery from "./pages/Gallery/EditGallery";
import MerchantIndex from "./pages/Merchant";
import AddMerchant from "./pages/Merchant/AddMerchant";
import EditMerchant from "./pages/Merchant/EditMerchant";
import AddPortfolio from "./pages/MerchantPortfolio/AddPortfolio";
import PortfolioIndex from "./pages/MerchantPortfolio";
import EditPortfolio from "./pages/MerchantPortfolio/EditPortfolio";
import BlogCategory from "./pages/BlogCategory";
import AddBlogCategory from "./pages/BlogCategory/AddBlogCategory";
import EditBlogCategory from "./pages/BlogCategory/EditBlogCategory";
import BlogIndex from "./pages/Blog";
import TourGuide from "./pages/TourGuide/Index.js"
import AddTourGuide from "./pages/TourGuide/AddTourGuide"
import AddBlog from "./pages/Blog/AddBlog";
import EditBlog from "./pages/Blog/EditBlog";
import Feedback from "./pages/Feedback"
import PartnerIndex from "./pages/Partner";
import PartnerDetails from "./pages/Partner/PartnerDetails";
import AddPartner from "./pages/Partner/AddPartner";
import EditPartner from "./pages/Partner/EditPartner";
import PartnerPlaces from "./pages/PartnerPlaces";
import AdminOnlineTickets from "./pages/OnlineTickets";
import AdminCounterTickets from "./pages/CounterTickets";
import AdminTicketHistory from "./pages/TicketHistory";
import AdminTransactionHistory from "./pages/TransactionHistory";
import GovernmentPartnerIndex from "./pages/GovernmentPartner";
import AddGovernmentPartner from "./pages/GovernmentPartner/AddPartner";
import EditGovernmentPartner from "./pages/GovernmentPartner/EditPartner";
import EventIndex from "./pages/Event";
import AddEvent from "./pages/Event/AddEvent";
import EditEvent from "./pages/Event/EditEvent";
import SchemeIndex from "./pages/Scheme";
import Subscribers from "./pages/Subscribers";
import AddScheme from "./pages/Scheme/AddScheme";
import EditScheme from "./pages/Scheme/EditScheme";
import EditAdmin from "./pages/AdminUsers/EditAdmin";
import SeoIndex from "./pages/Seo";
import ReviewCategoryIndex from "./pages/ReviewCategory";
import AddReviewCategory from "./pages/ReviewCategory/AddReviewCategory";
import InnerLinePermissionIndex from "./pages/InnerLinePermission";
import AddInnerLinePermission from "./pages/InnerLinePermission/AddInnerLinePermission";
import AddSeo from "./pages/Seo/AddSeo";
import EditSeo from "./pages/Seo/EditSeo";
import BookingIndex from "./pages/Booking";
import SubSubCategory from "./pages/SubSubCategory/SubSubCategory";
import AddSubSubCategory from "./pages/SubSubCategory/AddSubSubCategory";
import UpdateSubSubCategory from "./pages/SubSubCategory/UpdateSubSubCategory";
import Location from "./pages/location/Location";
import AddLocation from "./pages/location/AddLocation";
import UpdateLocation from "./pages/location/UpdateLocation";
import AddTownDetails from "./pages/location/AddTownDetails";
import TownGallery from "./pages/location/TownGallery";
import Destination from "./pages/destination/Destination";
import AddDestination from "./pages/destination/AddDestination";
import UpdateDestination from "./pages/destination/UpdateDestination";
import UpdateDestinationDetails from "./pages/destination/UpdateDestinationDetails";
import StateIndex from "./pages/State";
import AddState from "./pages/State/AddState";
import EditState from "./pages/State/EditState";
import StateHeaderIndex from "./pages/StateHeader";
import AddStateHeader from "./pages/StateHeader/AddStateHeader";
import EditStateHeader from "./pages/StateHeader/EditStateHeader";
import StateGallery from "./pages/State/StateGallery";
import BestTimeToVisit from "./pages/State/BestTimeToVisit"
import AddStateDetails from "./pages/State/AddStateDetails"
import City from "./pages/City/City";
import AddCity from "./pages/City/AddCity";
import UpdateCity from "./pages/City/UpdateCity";
import AddCityDetails from "./pages/City/AddCityDetails";
import CityGallery from "./pages/City/CityGallery";
import Index from "./pages/OnlineBooking/index";
import AddOnlineBook from "./pages/OnlineBooking/AddOnlineBook";
import EditOnlineBook from "./pages/OnlineBooking/EditOnlineBook";
import IndexTourCategory from "./pages/TourCategory/TourCategoryIndex";
import AddTourCategory from "./pages/TourCategory/AddTourCategory";
import EditTourCategory from "./pages/TourCategory/EditTourCategory";
import PriceMaster from "./pages/TicketInfo/PriceMaster";
import TermsAndCondition from "./pages/TicketInfo/TermsAndCondition";
import CancellationPolicy from "./pages/TicketInfo/CancellationPolicy";
import RefundPolicy from "./pages/TicketInfo/RefundPolicy";
import TouristType from "./pages/TicketInfo/TouristType";
import BookingForms from "./pages/TicketInfo/BookingForms.js";
import EnquiryIndex from "./pages/Enquiry/index";
import SubCategoryGallery from "./pages/SubCategory/SubCategoryGallery";
import QrCodeGenerator from "./pages/QrCodeGenerator";


import Orgnizations from "./pages/orgnizations/Dashboard.js";
import Rating from "./pages/orgnizations/Rating/index.js";
import SuggestionsFeedback from "./pages/orgnizations/SuggestionFeedback";
import HelpSupport from "./pages/orgnizations/HelpSupport";
import OnlineTickets from "./pages/orgnizations/OnlineTickets";
import GeneralTicket from "./pages/orgnizations/GeneralTicket";
import TicketHistory from "./pages/orgnizations/TicketHistory";
import TransactionHistory from "./pages/orgnizations/TransactionHistory";
import DashboardSuper from "./pages/orgnizations/DashboardSuper";
import CounterTicketsSuper from "./pages/orgnizations/CounterTicketsSuper";
import BookingsSuper from "./pages/orgnizations/BookingsSuper";
import OnlineTicketsSuper from "./pages/orgnizations/OnlineTicketsSuper";
import TransactionSuper from "./pages/orgnizations/TransactionSuper";
import PartnerSuper from "./pages/orgnizations/PartnerSuper";
import PartnerPerformanceOrg from "./pages/orgnizations/PartnerPerformance";
import MerchantPerformance from "./pages/orgnizations/MerchantPerformance";
import SettlementsSuper from "./pages/orgnizations/SettlementsSuper";
import InvoicesSuper from "./pages/orgnizations/InvoicesSuper";
import SubscriptionSuper from "./pages/orgnizations/SubscriptionSuper";
import RefundsSuper from "./pages/orgnizations/RefundsSuper";
import IncentivesSuper from "./pages/orgnizations/IncentivesSuper";
import HelpSupportSuper from "./pages/orgnizations/HelpSupportSuper";
import Booking from "./pages/orgnizations/Booking";
import Settlements from "./pages/Settlement";
import CreateSettlement from "./pages/Settlement/CreateSettlement";
import Invoices from "./pages/Invoices";
import CreateInvoice from "./pages/Invoices/CreateInvoice";
import PartnerPerformance from "./pages/PartnerPerformance";
import Notifications from "./pages/Notifications";
import FeedbackChat from "./pages/Partner/FeedbackChat";
import PlaceDetails from "./pages/Place/PlaceDetails";
import PartnersList from "./pages/Partner/partnersList.js";
import PartnerApplicationDetails from "./pages/PartnerApplicationDetails";


const AppRoutes = () => {
  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/add-admin-user" element={<CreateAdmin />} />
          <Route path="/create-role" element={<CreateRole />} />
          <Route path="/role" element={<Roles />} />
          <Route path="/category-list" element={<Category />} />
          <Route path="/edit-category/:id" element={<UpdateCategory />} />
          <Route path="/add-category" element={<AddCategory />} />
          <Route path="/subcategory" element={<Subcategory />} />
          <Route path="/add-subcategory" element={<AddSubCategory />} />
          <Route path="/update-subcategory/:id" element={<UpdateSubCategory />} />
          <Route path="/subsubcategory" element={<SubSubCategory />} />
          <Route path="/add-subsubcategory" element={<AddSubSubCategory />} />
          <Route path="/update-subsubcategory/:id" element={<UpdateSubSubCategory />} />
          <Route path="/subcategory-gallery/:id" element={<SubCategoryGallery />} />
          <Route path="/city" element={<City />} />
          <Route path="/add-city" element={<AddCity />} />
          <Route path="/update-city/:id" element={<UpdateCity />} />
          <Route path="/add-city-details/:id" element={<AddCityDetails />} />
          <Route path="/city-gallery/:id" element={<CityGallery />} />
          <Route path="/location" element={<Location />} />
          <Route path="/add-location" element={<AddLocation />} />
          <Route path="/update-location/:id" element={<UpdateLocation />} />
          <Route path="/add-town-details/:id" element={<AddTownDetails />} />
          <Route path="/town-gallery/:id" element={<TownGallery />} />
          <Route path="/destination" element={<Destination />} />
          <Route path="/add-destination" element={<AddDestination />} />
          <Route path="/update-destination/:id" element={<UpdateDestination />} />
          <Route path="/edit-destination-details/:id" element={<UpdateDestinationDetails />} />
          <Route path="/assign-permissions" element={<AssignPermissions />} />
          <Route path="/permissions" element={<Permissions />} />
          <Route path="/faqs" element={<Faq />} />
          <Route path="/admin-users" element={<AdminUsers />} />
          <Route path="/admin-users/edit/:id" element={<EditAdmin />} />
          <Route path="/offer-list" element={<Offerlist />} />
          <Route path="/add-offer" element={<AddOffer />} />
          <Route path="/offer-update/:id" element={<EditOffer />} />
          <Route path="/banner-list" element={<Bannerlist />} />
          <Route path="/add-banner" element={<AddBanner />} />
          <Route path="/banner-update/:id" element={<EditBanner />} />
          <Route path="/organization-list" element={<OrganizationList />} />
          <Route path="/add-organization" element={<AddOrganization />} />
          <Route path="/edit-organization/:id" element={<UpdateOrganization />} />
          <Route path="/organization-video-list" element={<OrganizationVideoList />} />
          <Route path="/add-organization-video" element={<AddOrganizationVideo />} />
          <Route path="/edit-organization-video/:id" element={<EditOrganizationVideo />} />
          <Route path="/check-this-out" element={<CheckThisOut />} />
          <Route path="/add-check-this-out" element={<AddCheckThisOut />} />
          <Route path="/update-check-this-out/:id" element={<EditCheckThisOut />} />
          <Route path="/user-topups" element={<UserTopUp />} />
          <Route path="/place-list" element={<Place />} />
          <Route path="/add-place" element={<AddPlace />} />
          <Route path="/add-place-details/:id" element={<AddPlaceDetails />} />
          <Route path="/add-ticket-type" element={<AddTicketType />} />
          <Route path="/add-ticket-info" element={<TicketInfo />} />
          <Route path="/edit-ticket-info/:id" element={<TicketInfo />} />
          <Route path="/booking-forms" element={<BookingForms />} />
          <Route path="/ticket-zone" element={<PlaceZone />} />
          <Route path="/safari-vehicles" element={<SafariVehicles />} />
          <Route path="/price-master" element={<PriceMaster />} />
          <Route path="/tourist-type" element={<TouristType />} />
          <Route path="/terms-and-conditoin" element={<TermsAndCondition />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/edit-place/:id" element={<EditPlace />} />
          <Route path="/gallery-list" element={<GalleryIndex />} />
          <Route path="/home-page" element={<HomePageIndex />} />
          <Route path="/add-gallery" element={<AddGallery />} />
          <Route path="/add-home" element={<AddHome />} />
          <Route path="/edit-gallery/:id" element={<EditGallery />} />
          <Route path="/merchants" element={<MerchantIndex />} />
          <Route path="/add-merchant" element={<AddMerchant />} />
          <Route path="/edit-merchant/:id" element={<EditMerchant />} />
          <Route path="/portfolio" element={<PortfolioIndex />} />
          <Route path="/add-portfolio" element={<AddPortfolio />} />
          <Route path="/edit-portfolio/:id" element={<EditPortfolio />} />
          <Route path="/blog-category" element={<BlogCategory />} />
          <Route path="/add-blog-category" element={<AddBlogCategory />} />
          <Route path="/edit-blog-category/:id" element={<EditBlogCategory />} />
          <Route path="/blogs" element={<BlogIndex />} />
          <Route path="/tour-guide" element={<TourGuide />} />
          <Route path="/add-tour-guide" element={<AddTourGuide />} />
          <Route path="/add-blog" element={<AddBlog />} />
          <Route path="/edit-blog/:id" element={<EditBlog />} />
          <Route path="/partners" element={<PartnersList />} />
          <Route path="/approved-partners" element={<PartnerIndex />} />
          <Route path="/pending-partners" element={<PartnerIndex />} />
          <Route path="/rejected-partners" element={<PartnerIndex />} />
          <Route path="/partner-requests" element={<PartnerIndex />} />
          <Route path="/partner-details/:id" element={<PartnerDetails />} />
          <Route path="/partner-application-details/:id" element={<PartnerApplicationDetails />} />
          <Route path="/partner-places" element={<PartnerPlaces />} />
          <Route path="/enquiries" element={<EnquiryIndex />} />
          <Route path="/add-partner" element={<AddPartner />} />
          <Route path="/edit-partner/:id" element={<EditPartner />} />
          <Route path="/government-partners" element={<GovernmentPartnerIndex />} />
          <Route path="/add-government-partner" element={<AddGovernmentPartner />} />
          <Route path="/edit-government-partner/:id" element={<EditGovernmentPartner />} />
          <Route path="/events" element={<EventIndex />} />
          <Route path="/add-event" element={<AddEvent />} />
          <Route path="/edit-event/:id" element={<EditEvent />} />
          <Route path="/schemes" element={<SchemeIndex />} />
          <Route path="/subscribers" element={<Subscribers />} />
          <Route path="/add-scheme" element={<AddScheme />} />
          <Route path="/edit-scheme/:id" element={<EditScheme />} />
          <Route path="/review-category" element={<ReviewCategoryIndex />} />
          <Route path="/add-review-category" element={<AddReviewCategory />} />
          <Route path="/add-review-category/:id" element={<AddReviewCategory />} />
          <Route path="/inner-line-permission" element={<InnerLinePermissionIndex />} />
          <Route path="/add-inner-line-permission" element={<AddInnerLinePermission />} />
          <Route path="/add-inner-line-permission/:id" element={<AddInnerLinePermission />} />
          <Route path="/seo-lists" element={<SeoIndex />} />
          <Route path="/add-seo" element={<AddSeo />} />
          <Route path="/edit-seo/:id" element={<EditSeo />} />
          <Route path="/state-lists" element={<StateIndex />} />
          <Route path="/state-headers" element={<StateHeaderIndex />} />
          <Route path="/add-state-header" element={<AddStateHeader />} />
          <Route path="/edit-state-header/:id" element={<EditStateHeader />} />
          <Route path="/add-state" element={<AddState />} />
          <Route path="/state-gallery/:id" element={<StateGallery />} />
          <Route path="/best-time-to-visit/:id" element={<BestTimeToVisit />} />
          <Route path="/add-state-details/:id" element={<AddStateDetails />} />
          <Route path="/edit-state/:id" element={<EditState />} />
          <Route path="/booking-list" element={<BookingIndex />} />
          <Route path="/online-booking" element={<Index />} />
          <Route path="/add-online-booking" element={<AddOnlineBook />} />
          <Route path="/edit-online-booking/:id" element={<EditOnlineBook />} />
          <Route path="/tour-category" element={<IndexTourCategory />} />
          <Route path="/add-tour-category" element={<AddTourCategory />} />
          <Route path="/edit-tour-category/:id" element={<EditTourCategory />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/online-tickets" element={<AdminOnlineTickets />} />
          <Route path="/counter-tickets" element={<AdminCounterTickets />} />
          <Route path="/ticket-history" element={<AdminTicketHistory />} />
          <Route path="/transaction-history" element={<AdminTransactionHistory />} />
          <Route path="/settlements" element={<Settlements />} />
          <Route path="/settlements/create" element={<CreateSettlement />} />
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/invoices/create" element={<CreateInvoice />} />
          <Route path="/partner-performance" element={<PartnerPerformance />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/feedback-chat/:feedbackId" element={<FeedbackChat />} />
          <Route path="/place-details/:id" element={<PlaceDetails />} />
          <Route path="/qr-code-generator" element={<QrCodeGenerator />} />
          
          <Route path="*" element={<h2>Not Found</h2>} />
        </Route>
        <Route element={<OrgLayout />}>
        <Route path="/orgnizations" element={<Orgnizations />} />
        <Route path="/orgnizations/ratings-reviews" element={<Rating />} />
        <Route path="/orgnizations/suggestions-feedback" element={<SuggestionsFeedback />} />
        <Route path="/orgnizations/help-support" element={<HelpSupport />} />
        <Route path="/orgnizations/online-tickets" element={<OnlineTickets />} />
        <Route path="/orgnizations/general-tickets" element={<GeneralTicket />} />
        <Route path="/orgnizations/ticket-history" element={<TicketHistory />} />
        <Route path="/orgnizations/transaction-history" element={<TransactionHistory />} />
        <Route path="/orgnizations/dashboard-super" element={<DashboardSuper />} />
        <Route path="/orgnizations/counter-tickets-super" element={<CounterTicketsSuper />} />
        <Route path="/orgnizations/bookings-super" element={<BookingsSuper />} />
        <Route path="/orgnizations/online-tickets-super" element={<OnlineTicketsSuper />} />
        <Route path="/orgnizations/transaction-super" element={<TransactionSuper />} />
        <Route path="/orgnizations/partner-super" element={<PartnerSuper />} />
        <Route path="/orgnizations/performance/partner" element={<PartnerPerformanceOrg />} />
        <Route path="/orgnizations/performance/merchant" element={<MerchantPerformance />} />
        <Route path="/orgnizations/settlements-super" element={<SettlementsSuper />} />
        <Route path="/orgnizations/invoices-super" element={<InvoicesSuper />} />
        <Route path="/orgnizations/subscription-super" element={<SubscriptionSuper />} />
        <Route path="/orgnizations/refunds-super" element={<RefundsSuper />} />
        <Route path="/orgnizations/incentives-super" element={<IncentivesSuper />} />
        <Route path="/orgnizations/help-support-super" element={<HelpSupportSuper />} />
         <Route path="/orgnizations/booking-list" element={<Booking />} />

        </Route>
        <Route path="/login" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
